import { TFormatMessageOptions } from './types';
import { PLACEHOLDERS } from '../constants';
import { doesMessageHasRandomNumbers } from './doesMessageHasRandomNumbers';

/**
 * Will return the message formatted with the lead data
 *
 * @param {string} message
 * @param {TFormatMessageOptions} options
 * @return {*}  {string}
 */
export const formatMessage = (
    message: string,
    options: TFormatMessageOptions
): string => {
    let response = message;

    PLACEHOLDERS.forEach((placeholder) => {
        const value = options[placeholder];
        if (value) {
            response = response.replace(
                new RegExp(`{{${placeholder}}}`, 'gi'),
                value
            );
        }
    });

    if (doesMessageHasRandomNumbers(message)) {
        response = response.replace(
            /{{randomNumber\[(\d+),(\d+)\]}}/g,
            options.randomNumber || '0'
        );
    }

    return response;
};
